import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import App from './App';
import './index.css'
import { Provider } from 'react-redux'
import store from './redux/store/index'

ReactDOM.render(
    <Provider store={store}>
    <HashRouter>
        <App />
        </HashRouter>
        </Provider>
    ,
    document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js